var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var import_Lightbox = require("./Lightbox.css");
"use strict";
const vue = require("vue");
const close = require("./close-d4326b17.js");
const _pluginVue_exportHelper = require("./_plugin-vue_export-helper-9c783a34.js");
const SCRIPT_CACHE = {};
class EmbedConfig {
  constructor(url) {
    __publicField(this, "handlers", {});
    /* tslint:enable variable-name */
    __publicField(this, "autoplay", false);
    /**
     * These methods are used to proxy the implemented players' play actions,
     * so that the interface is shared between different video providers.
     *
     * @see EmbedConfig#play()
     * @see EmbedConfig#pause()
     */
    __publicField(this, "actions", {});
    /* tslint:disable variable-name */
    __publicField(this, "_id", "");
    this.url = url;
    this.resetActionsAndHandlers();
  }
  get id() {
    return this._id;
  }
  static isMatch(url) {
    const m = url.match(this.matcher);
    return m != null && m.length > 1;
  }
  on(event, handler) {
    this.handlers[event] = handler;
  }
  play() {
    return this.actions.play();
  }
  pause() {
    return this.actions.pause();
  }
  destroy() {
    return this.actions.destroy();
  }
  setAutoplay(value) {
    this.autoplay = value;
  }
  extractId(matcher) {
    const match = this.url.match(matcher);
    if (match) {
      this._id = match[this.idPosition];
    }
  }
  addScript(didLoad, appendWhere = document.body) {
    return new Promise((resolve, reject) => {
      if (didLoad()) {
        resolve();
        return;
      }
      const extractedPromise = { resolve, reject };
      if (SCRIPT_CACHE[this.api]) {
        SCRIPT_CACHE[this.api].push(extractedPromise);
        return;
      }
      SCRIPT_CACHE[this.api] = [extractedPromise];
      const scriptElement = document.createElement("script");
      scriptElement.src = this.api;
      scriptElement.addEventListener("load", () => {
        SCRIPT_CACHE[this.api].forEach((value) => {
          if (didLoad()) {
            value.resolve();
          } else {
            value.reject(
              `Loaded script (${this.api}) but didLoad() method returned false.`
            );
          }
        });
      });
      scriptElement.addEventListener("error", () => {
        SCRIPT_CACHE[this.api].forEach((value) => {
          value.reject(`Error loading script (${this.api}).`);
        });
      });
      appendWhere.appendChild(scriptElement);
    });
  }
  resetActionsAndHandlers() {
    const defaultFunctions = {};
    this.handlers = Object.assign({}, defaultFunctions);
    this.actions = Object.assign({}, defaultFunctions);
  }
}
__publicField(EmbedConfig, "matcher");
class VimeoEmbedConfig extends EmbedConfig {
  constructor(url) {
    super(url);
    // NOOP, but required
    __publicField(this, "idPosition", 2);
    __publicField(this, "api", "https://player.vimeo.com/api/player.js");
    this.url = url;
  }
  getThumb() {
    return Promise.resolve("");
  }
  initPlayer(target) {
    return new Promise((resolve) => {
      this.loadApi().then(() => {
        const player = new window.Vimeo.Player(target, {
          url: this.url
        });
        player.on("play", () => this.handlers.play());
        player.on("pause", () => this.handlers.pause());
        player.on("ended", () => this.handlers.pause());
        this.actions.play = () => player.play();
        this.actions.pause = () => player.pause();
        this.actions.destroy = () => player.destroy();
        resolve(player);
      });
    });
  }
  loadApi() {
    return this.addScript(() => {
      return !!window.Vimeo;
    });
  }
}
// Used in embedConfig to math url to config
__publicField(VimeoEmbedConfig, "matcher", /vimeo\.com\/(.*\/)?([0-9]+)(\?h=\w*)?/i);
const getThumbnail = (id) => {
  const MAX_RES_THRESHOLD = 800;
  const DEFAULT_URLS = {
    MAX_RES: `https://img.youtube.com/vi/${id}/maxresdefault.jpg`,
    HQ: `https://img.youtube.com/vi/${id}/hqdefault.jpg`
  };
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      if (img.width >= MAX_RES_THRESHOLD) {
        resolve(DEFAULT_URLS.MAX_RES);
      } else {
        resolve(DEFAULT_URLS.HQ);
      }
    };
    img.onerror = () => {
      resolve(DEFAULT_URLS.HQ);
    };
    img.src = DEFAULT_URLS.MAX_RES;
  });
};
const ALL_YOUTUBE_EMBED_RESOLVES = [];
let YT_IFRAME_API_READY = false;
const _YoutubeEmbedConfig = class extends EmbedConfig {
  constructor(url) {
    super(url);
    __publicField(this, "idPosition", 4);
    __publicField(this, "api", "https://www.youtube.com/iframe_api");
    this.url = url;
    this.extractId(_YoutubeEmbedConfig.matcher);
  }
  getThumb() {
    return getThumbnail(this.id);
  }
  initPlayer(target) {
    const detectionSpeed = 100;
    const pauseDebounce = 100;
    let pauseTimeout = 0;
    let prevTime = -1;
    const onPlayerReady = (event) => {
      window.setInterval(() => {
        const currentTime = event.target.getCurrentTime();
        if (Math.abs(currentTime - prevTime) > 0.5) {
          clearTimeout(pauseTimeout);
        }
        prevTime = currentTime;
      }, detectionSpeed);
    };
    const onPlayerStateChange = (event) => {
      const { ENDED, PLAYING, PAUSED } = window.YT.PlayerState;
      clearTimeout(pauseTimeout);
      switch (event.data) {
        case PLAYING:
          if (this.handlers.play) {
            this.handlers.play();
          }
          break;
        case PAUSED:
          pauseTimeout = window.setTimeout(() => {
            if (this.handlers.pause) {
              this.handlers.pause();
            }
          }, pauseDebounce);
          break;
        case ENDED:
          if (this.handlers.pause) {
            this.handlers.pause();
          }
          break;
      }
    };
    return new Promise((resolve) => {
      this.loadApi().then(() => {
        const player = new window.YT.Player(target, {
          playerVars: { autoplay: this.autoplay, rel: 0 },
          videoId: this.id,
          host: "https://www.youtube-nocookie.com",
          events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange
          }
        });
        this.actions.play = () => player.playVideo();
        this.actions.pause = () => player.pauseVideo();
        this.actions.destroy = () => player.destroy();
        resolve(player);
      });
    });
  }
  loadApi() {
    return new Promise((resolve) => {
      ALL_YOUTUBE_EMBED_RESOLVES.push(resolve);
      window.onYouTubeIframeAPIReady = () => {
        YT_IFRAME_API_READY = true;
        ALL_YOUTUBE_EMBED_RESOLVES.forEach((resolveToCall) => resolveToCall());
      };
      this.addScript(() => {
        return !!window.YT;
      }).finally(() => {
        if (YT_IFRAME_API_READY) {
          resolve();
        }
      });
    });
  }
};
let YoutubeEmbedConfig = _YoutubeEmbedConfig;
__publicField(YoutubeEmbedConfig, "matcher", /(youtube\.com|youtu\.be|youtube-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i);
const _YoukuEmbedConfig = class extends EmbedConfig {
  constructor(url) {
    super(url);
    __publicField(this, "idPosition", 4);
    __publicField(this, "api", "https://player.youku.com/jsapi");
    this.url = url;
    this.extractId(_YoukuEmbedConfig.matcher);
  }
  getThumb() {
    return Promise.resolve("");
  }
  initPlayer(target) {
    return new Promise((resolve) => {
      this.loadApi().then(() => {
        const player = new window.YKU.Player(target.id, {
          client_id: "44503cca1be605b5",
          vid: this.id,
          events: {
            "onPlayStart": () => this.handlers.play(),
            "onPlayEnd": () => this.handlers.pause()
          }
        });
        this.actions.play = () => player.playVideo();
        this.actions.pause = () => player.pauseVideo();
        this.actions.destroy = () => {
        };
        resolve(player);
      });
    });
  }
  loadApi() {
    return this.addScript(() => {
      return !!window.YKU;
    });
  }
};
let YoukuEmbedConfig = _YoukuEmbedConfig;
__publicField(YoukuEmbedConfig, "matcher", /(youku\.com\/)(.*\/)(id_)(.*)/i);
const createEmbedConfig = (url) => {
  const embedConfig = [YoutubeEmbedConfig, VimeoEmbedConfig, YoukuEmbedConfig].find(
    (entry) => entry.isMatch(url)
  );
  return embedConfig ? new embedConfig(url) : null;
};
const _hoisted_1 = ["onClick"];
const _hoisted_2 = { key: 0 };
const _hoisted_3 = ["id"];
const _hoisted_4 = ["id"];
const _hoisted_5 = {
  key: 1,
  class: "img-container"
};
const _hoisted_6 = ["src"];
const _sfc_main = /* @__PURE__ */ vue.defineComponent({
  props: {
    content: { default: "" },
    mediaType: { default: "video" }
  },
  setup(__props, { expose }) {
    const props = __props;
    let modalContentType = vue.ref("");
    let show = vue.ref(false);
    const videoEmbed = vue.ref(null);
    vue.ref("");
    let modalContents = vue.reactive({});
    const embedConfig = vue.computed(() => {
      return modalContents;
    });
    const isShowing = vue.computed(() => {
      return show.value;
    });
    function close$1() {
      if (props.mediaType === "video") {
        modalContents.destroy();
      }
      show.value = false;
    }
    function open() {
      initialize();
      show.value = true;
    }
    vue.onMounted(() => {
      document.addEventListener("keyup", (e) => {
        if (e.key === "Escape") {
          close$1();
        }
      });
    });
    function initialize() {
      const content = props.content;
      const mediaType = props.mediaType;
      if (mediaType === "image") {
        modalContentType.value = "image";
        return;
      }
      modalContentType.value = "video";
      const embedConfig2 = createEmbedConfig(content);
      if (!embedConfig2) {
        return;
      }
      modalContents = embedConfig2;
      const embed = modalContents;
      vue.nextTick(() => {
        const embedTarget = videoEmbed.value.querySelector(".embed-responsive-item");
        embed.setAutoplay(true);
        embed.initPlayer(embedTarget);
      });
    }
    function afterModalClose() {
      modalContentType.value = "";
    }
    expose({
      open
    });
    return (_ctx, _cache) => {
      return vue.openBlock(), vue.createBlock(vue.Transition, {
        name: "modal",
        onAfterLeave: afterModalClose
      }, {
        default: vue.withCtx(() => [
          vue.withDirectives(vue.createElementVNode("div", {
            class: "modal-mask",
            onClick: close$1
          }, [
            vue.createElementVNode("div", {
              class: vue.normalizeClass(["modal-container", vue.unref(modalContentType) === "image" ? "modal-container-image" : ""]),
              onClick: _cache[0] || (_cache[0] = vue.withModifiers(() => {
              }, ["stop"]))
            }, [
              vue.createElementVNode("button", {
                class: "modal-close",
                onClick: vue.withModifiers(close$1, ["prevent"])
              }, [
                vue.createVNode(vue.unref(close.CloseIcon))
              ], 8, _hoisted_1),
              vue.createElementVNode("div", {
                ref_key: "videoEmbed",
                ref: videoEmbed
              }, [
                vue.unref(modalContentType) === "video" && vue.unref(embedConfig) !== void 0 ? (vue.openBlock(), vue.createElementBlock("div", _hoisted_2, [
                  vue.createElementVNode("div", {
                    id: `video-${vue.unref(embedConfig).id}`,
                    class: vue.normalizeClass([`embed-responsive-16by9`, "embed-responsive"])
                  }, [
                    vue.createElementVNode("div", {
                      id: `video-${vue.unref(embedConfig).id}-target`,
                      class: "embed-responsive-item"
                    }, null, 8, _hoisted_4)
                  ], 8, _hoisted_3)
                ])) : (vue.openBlock(), vue.createElementBlock("div", _hoisted_5, [
                  vue.createElementVNode("img", {
                    src: __props.content,
                    alt: ""
                  }, null, 8, _hoisted_6)
                ]))
              ], 512)
            ], 2)
          ], 512), [
            [vue.vShow, vue.unref(isShowing)]
          ])
        ]),
        _: 1
      });
    };
  }
});
const Lightbox_vue_vue_type_style_index_0_scoped_aa962ef1_lang = "";
const Lightbox = /* @__PURE__ */ _pluginVue_exportHelper._export_sfc(_sfc_main, [["__scopeId", "data-v-aa962ef1"]]);
exports.Lightbox = Lightbox;
exports.createEmbedConfig = createEmbedConfig;
